import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcRemoteSessions = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M15.89 4.61a5.5 5.5 0 0 0-7.779 0 1 1 0 1 1-1.414-1.413 7.5 7.5 0 0 1 10.607 0A1 1 0 0 1 15.89 4.61Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M10.232 6.732a2.5 2.5 0 0 1 3.536 0 1 1 0 1 0 1.414-1.414 4.5 4.5 0 0 0-6.364 0 1 1 0 0 0 1.414 1.414ZM16.5 8.5c0 .256-.021.506-.062.75h2.812v7.25H4.75V9.25h2.812a4.53 4.53 0 0 1 .05-1.75H4.5A1.5 1.5 0 0 0 3 9v9.5A1.5 1.5 0 0 0 4.5 20H10v2H9a.5.5 0 1 0 0 1h6a.5.5 0 0 0 0-1h-1v-2h5.5a1.5 1.5 0 0 0 1.5-1.5V9a1.5 1.5 0 0 0-1.5-1.5h-3.111c.073.322.111.656.111 1Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "12",
  cy: "8.5",
  fill: "var(--mds-nav-icon-accent)",
  r: "1.5"
})), "IcRemoteSessions");

export { IcRemoteSessions };
//# sourceMappingURL=ic-remote-sessions.js.map
